<template>
  <div style="height: 100%;width: 100%">
    <div class="box-three">
      <div class="img-top">
        <el-row style="text-align: center">
          <el-col :span="8">
            <img src="../../../assets/SHscreen/index_service_1.png">
          </el-col>
          <el-col :span="8">
            <img src="../../../assets/SHscreen/index_service_2.png">
          </el-col>
          <el-col :span="8">
            <img src="../../../assets/SHscreen/index_service_4.png">
          </el-col>
        </el-row>
      </div>
      <div class="text-top1">
        <el-row style="text-align: center">
          <el-col :span="8">
            <span>服务商</span>
          </el-col>
          <el-col :span="8">
            <span>服务人员</span>
          </el-col>
          <el-col :span="8">
<!--            <span>律师数量</span>-->
            <span>服务内容</span>
          </el-col>
        </el-row>
      </div>
      <div class="text-top2">
        <el-row style="text-align: center">
          <el-col :span="8">
            <span style="color: #ffb618">{{suppliercount}}</span>
          </el-col>
          <el-col :span="8">
            <span style="color: #00ffaa">{{customerservicecount}}</span>
          </el-col>
          <el-col :span="8">
<!--            <span style="color: #00ffff">{{customeronlinecount}}</span>-->
<!--            <span style="color: #00ffff">{{lawercount}}</span>-->
            <span style="color: #00ffff">{{servicetypecount}}</span>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'indexService',
  props: {
    service: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      suppliercount: 0,
      customerservicecount: 0,
      customeronlinecount: 0,
      lawercount: 0,
      servicetypecount: 0
    }
  },
  created () {
    // 服务资源
    // console.log(this.service)
    this.suppliercount = this.service.suppliercount
    this.customerservicecount = this.service.customerservicecount
    this.customeronlinecount = this.service.customeronlinecount
    this.lawercount = this.service.lawercount
    this.servicetypecount = this.service.servicetypecount
  },
  methods: {
    getRefresh (obj) {
      // console.log('服务资源')
      this.suppliercount = obj.suppliercount
      this.customerservicecount = obj.customerservicecount
      this.customeronlinecount = obj.customeronlinecount
      this.lawercount = obj.lawercount
      this.servicetypecount = obj.servicetypecount
    }
  }
}
</script>

<style scoped>
.box-three{
  position: relative;
  width: 100%;
  height: 130px;
  top: 50%;
  margin-top: -65px;
}
  .img-top{
    height: 70px;
  }
  .img-top img{
    width: 69px;
    height: 64px;
  }
  .text-top1{
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    color: #e1e3ef;
  }
  .text-top2{
    height: 30px;
    line-height: 30px;
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/monitoring/bigComponents/indexService.vue